import React from 'react';
import { Link } from 'react-router-dom';

import './izvestajitem.styles.css';


const IzvestajItem = props =>{ 
   
    return(      
        <article className="izvestaj-card">            
            <img className="izvestaj-card__image" src={props.image} alt={props.naslov} />
            <h2>{props.naslov}</h2>                         
            <p><Link to={`izvestaji/${props.id}`} className="izvestaj-card__button" >Pročitaj više &gt;&gt;</Link></p>
        </article>     
    )

}

export default IzvestajItem